import React from "react";
import DoctorNotifications from "../DoctorNotifications/DoctorNotifications";
import useHospitalProviderRole from "./useHospitalProviderRole";

export default function HospitalNotifications() {
  useHospitalProviderRole();
  return <DoctorNotifications />;
}
